import { CheckIcon } from '@umanforge/common';
import React from 'react';

interface ToggleButtonProps {
  label?: string;
  isSelected: boolean;
  onClick: () => void;
  seeCheck?: boolean;
  disable?: boolean;
  bgColor?: string;
  textColor?: string;
  HasOneSelected?: boolean;
}

const ToggleButton: React.FC<ToggleButtonProps> = ( { label, disable, HasOneSelected, textColor, seeCheck, isSelected, bgColor, onClick } ) => {
  return (
    <button
      disabled={ disable }
      className={`relative inline-flex items-center rounded-md ${seeCheck ? 'pr-4' : ''} overflow-hidden border-2 border-transparent bg-white hover:shadow trans-fast hover:border-gray-600 
        ${isSelected ? 'text-app-color-dark shadow' : 'text-gray-base-dark'}
        ${!isSelected && HasOneSelected && bgColor ? 'opacity-35' : ''}
      `}
      onClick={onClick}
      style={{
        backgroundColor: bgColor,
        color: textColor,
      }}
    >
      <p className="z-10 min-h-8 px-2 py-2 whitespace-nowrap text-center">{label}</p>
      { ( isSelected && seeCheck ) && (
        <CheckIcon className="w-5 h-5 right-1 absolute z-10" />
      )
      }
      <div
        className={`absolute inset-0 ${bgColor ? bgColor : 'bg-app-color-very-light'} trans-fast-cube ${isSelected ? 'top-0' : 'top-[calc(100%)]'}`}
      />
    </button>
  );
};

export default ToggleButton;
